const API_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://phf-cms.upswell.cloud/api' : 'http://localhost:8888/api';

export const state = () => ({
    id_map: {},

    article: null,
    article_error: null,
    article_loading: false,

    articles: null,
    articles_page: null,
    articles_error: null,
    articles_loading: false
})

export const getters = {
    article: state => state.article,
    article_error: state => state.article_error,
    article_loading: state => state.article_loading,

    articles: state => state.articles,
    articles_page: state => state.articles_page,
    articles_error: state => state.articles_error,
    articles_loading: state => state.articles_loading
};

export const actions = {
    /**
     * Retrieve an article list page for Digital Augustan Rome
     */
    async fetch_list({ commit, state }) {
        if (state.articles) {
            return
        }
        commit('setArticlesLoading', true)

        try {
            // Step 1: Fetch the articles page to get its ID
            const req_page_url = `${API_BASE_URL}/find-path/?html_path=/articles/&site=${window.location.hostname}`;
            const pageResponse = await fetch(req_page_url);

            if (!pageResponse.ok) {
                throw new Error(`Articles page error ${pageResponse.status} : ${pageResponse.statusText}`)
            }

            const pageData = await pageResponse.json();

            if (!pageData.id) {
                throw new Error(`Articles error, cannot unwrap page ID`)
            }

            // Step 2: Fetch the list of articles using the page ID
            const req_list_url = `${API_BASE_URL}/pages/?child_of=${pageData.id}&type=generic.TextPage&fields=authors(*)&site=${window.location.hostname}`;

            const listResponse = await fetch(req_list_url);

            if (!listResponse.ok) {
                throw new Error(`Articles error ${listResponse.status} : ${listResponse.statusText}`)
            }

            const listData = await listResponse.json();
            commit('setArticles', listData.items)

        } catch (error) {
            console.error('fetch_list error:', error);
            commit('setArticlesError', error.message)
        }
    },

    /**
     * Retrieve a single article by slug
     */
    async fetch({ commit, state }, slug) {
        if (state.article && state.article.meta.slug === slug) {
            return
        }

        commit('setArticleLoading', true)

        try {
            const articleId = state.id_map[slug];

            if (!articleId) {
                throw new Error(`Article not found for slug: ${slug}`)
            }

            const req_url = `${API_BASE_URL}/pages/${articleId}/?fields=authors(*)&site=${window.location.hostname}`;
            const response = await fetch(req_url);

            if (!response.ok) {
                throw new Error(`Article error ${response.status} : ${response.statusText}`)
            }

            const data = await response.json();
            commit('setArticle', data)

        } catch (error) {
            console.error('fetch error:', error);
            commit('setArticleError', error.message)
        }
    },

    /**
     * Fetch the articles page metadata
     */
    async fetch_page({ commit, state }) {
        if (state.articles_page) {
            return
        }
        commit('setArticlesLoading', true)

        try {
            const req_url = `${API_BASE_URL}/pages/?slug=articles&type=dag.DigitalAugustanRomeStub&fields=preview_thumbnail_image`;
            const response = await fetch(req_url);

            if (!response.ok) {
                throw new Error(`Articles page error ${response.status} : ${response.statusText}`)
            }

            const data = await response.json();

            if (!data.items || !data.items[0] || !data.items[0].id) {
                throw new Error(`Articles page error, cannot unwrap page ID`)
            }

            commit('setArticlesPage', data)

        } catch (error) {
            console.error('fetch_page error:', error);
            commit('setArticlesPageError', error.message)
        }
    }
};

export const mutations = {
    setArticle(state, response) {
        state.article = response
        state.article_loading = false
    },
    setArticleError(state, e) {
        state.article_error = e
        state.article_loading = false
        throw new Error(`Error fetching article: ${e}`)
    },
    setArticleLoading(state, s) {
        state.article_loading = s
    },
    setArticles(state, response) {
        for (var i = 0; i < response.length; i++) {
            state.id_map[response[i].meta.slug] = response[i].id
        }
        state.articles = response
        state.articles_loading = false
    },
    setArticlesError(state, e) {
        state.articles_error = e
        state.articles_loading = false
        throw new Error(`Error fetching articles: ${e}`)
    },
    setArticlesPage(state, response) {
        state.articles_page = response
        state.articles_loading = false
    },
    setArticlesPageError(state, e) {
        state.articles_error = e
        state.articles_loading = false
        throw new Error(`Error fetching articles page: ${e}`)
    },
    setArticlesLoading(state, s) {
        state.articles_loading = s
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};